import { render } from "./sel-image.vue?vue&type=template&id=ba213d54&scoped=true"
import script from "./sel-image.vue?vue&type=script&lang=js"
export * from "./sel-image.vue?vue&type=script&lang=js"

import "./sel-image.vue?vue&type=style&index=0&id=ba213d54&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba213d54"]])

export default __exports__